import { Injectable } from '@angular/core';
import { NavService } from '../nav.service';
import { StateService } from '../state.service';
import { UiService } from '../ui.service';
import { ApiHelperService } from './api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CommonHelper {

  constructor(
    private stateService: StateService,
    private apiHelper: ApiHelperService,
    private nav: NavService,
    private ui: UiService,
  ) { }


  async identifyUser() {
    let codGuia = this.nav.getQueryParam('codGuia');
    let numPolizas = this.nav.getQueryParam('numPolizas');
    let state = this.stateService.getStateValue();
    
    const navTo = this.nav.getQueryParam('nav');
    if (navTo) {
      await this.apiHelper.setSearchEngineList({ ...state, userIdentified: false});
      this.nav.navTo(navTo); return;
    }


    if (!codGuia) {
      await this.apiHelper.setSearchEngineList({ ...state, userIdentified: false});

      if (codGuia === '' || (numPolizas === '0')) {
        this.ui.openerrorIdentifyUserModalComponent();
      };

      this.nav.navTo('home');
      return;
    }

    if (codGuia && numPolizas === '0') {
      this.ui.openerrorIdentifyUserModalComponent();
      this.nav.navTo('home');
      return;
    }

    const breadcrumbs = state.breadcrumbs;
    breadcrumbs[0].navTo = () => this.nav.navTo('services');

    state = this.formatUserIdentifiedState(state, breadcrumbs);
    codGuia = this.formatCodGuia(codGuia);

    this.stateService.updateState(state);
    this.apiHelper.setSearchEngineList({ ...state, userIdentified: true, codGuia });
    this.nav.navTo('services');
  }

  private formatCodGuia(codGuia: string): string {
    const codsGuia = codGuia.split(';');
    return codsGuia[0].length === 1 ? '0' + codsGuia[0] : codsGuia[0];
  }

  private formatUserIdentifiedState(state, breadcrumbs) {
    const codGuia = this.nav.getQueryParam('codGuia')?.split(';');
    const nomPolizas = this.nav.getQueryParam('nomPolizas')?.split(';');
    const contrato = this.nav.getQueryParam('contrato')?.split(';');
    const healthPolicies = [];
    codGuia.forEach((cod, index) => {
      healthPolicies.push({
        codGuia: cod,
        policyName: nomPolizas ? nomPolizas[index] : null,
        cardId: contrato ? contrato[index] : null
      });
    })

    return {
      ...state,
      codGuia,
      breadcrumbs,
      userIdentified: true,
      healthPolicies
    };
  }

}
